import { alpha } from "@mui/material/styles";

const styles = (theme) => ({
  container: {
    width: "100%",
    maxWidth: "100%",
    minWidth: 0,
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    position: "relative",
    overflowX: "hidden",
  },
  buttonRefresh: {
    color: theme.palette.text.textContrast,
    borderColor: theme.palette.text.main,
    minWidth: "25px",
    padding: "10px",
    lineHeight: 1,
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    gap: "16px",
    alignItems: "center",
    flexWrap: "wrap",
  },
  title: {
    color: theme.palette.text.primary,
    fontWeight: 700,
    fontSize: "1.5rem",
    lineHeight: 1.2,
    "@media (max-width: 600px)": {
      fontSize: "1.3rem",
    },
  },
  subtitle: {
    color: theme.palette.text.secondary,
    fontSize: "0.875rem",
    marginTop: "2px",
  },
  headerActions: {
    display: "flex",
    gap: "8px",
    flexWrap: "wrap",
    justifyContent: "flex-end",
  },
  filterPaper: {
    padding: "16px",
    borderRadius: "16px",
    border: `1px solid ${alpha(theme.palette.text.primary, 0.08)}`,
    backgroundColor: theme.palette.background.paper,
  },
  filterHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "12px",
    marginBottom: "12px",
    flexWrap: "wrap",
  },
  filterTitle: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    color: theme.palette.text.primary,
  },
  filterTitleText: {
    fontSize: "0.95rem",
    fontWeight: 700,
  },
  tabsPaper: {
    width: "100%",
    maxWidth: "100%",
    minWidth: 0,
    borderRadius: "16px",
    overflow: "hidden",
    border: `1px solid ${alpha(theme.palette.text.primary, 0.08)}`,
    backgroundColor: theme.palette.background.paper,
  },
  tabs: {
    minHeight: "48px",
    "& .MuiTab-root": {
      minHeight: "48px",
      fontSize: "0.82rem",
      fontWeight: 700,
      textTransform: "none",
    },
  },
  metricCard: {
    height: "100%",
    minHeight: "128px",
    borderRadius: "16px",
    padding: "16px",
    position: "relative",
    overflow: "hidden",
    border: `1px solid ${alpha(theme.palette.text.primary, 0.08)}`,
  },
  metricHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "10px",
  },
  metricIcon: {
    width: "34px",
    height: "34px",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  metricTitle: {
    color: theme.palette.text.secondary,
    fontSize: "12px",
    fontWeight: 700,
    textTransform: "uppercase",
  },
  metricValue: {
    color: theme.palette.text.primary,
    fontSize: "1.55rem",
    fontWeight: 800,
    lineHeight: 1.15,
    marginTop: "12px",
    "@media (max-width: 600px)": {
      fontSize: "1.35rem",
    },
  },
  metricHelper: {
    color: theme.palette.text.secondary,
    fontSize: "12px",
    marginTop: "6px",
  },
  chartCard: {
    height: "100%",
    minWidth: 0,
    overflow: "hidden",
    borderRadius: "16px",
    padding: "16px",
  },
  cardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "12px",
    marginBottom: "16px",
    minWidth: 0,
    "& > *": {
      minWidth: 0,
    },
  },
  cardTitle: {
    color: theme.palette.text.primary,
    fontSize: "16px",
    fontWeight: 600,
  },
  cardSubtitle: {
    color: theme.palette.text.secondary,
    fontSize: "12px",
  },
  chartBox: {
    width: "100%",
    maxWidth: "100%",
    minWidth: 0,
    height: "286px",
    minHeight: "260px",
    "@media (max-width: 600px)": {
      height: "252px",
      minHeight: "232px",
    },
  },
  chartTooltip: {
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${alpha(theme.palette.text.primary, 0.16)}`,
    borderRadius: "12px",
    color: theme.palette.text.primary,
    boxShadow: theme.shadows[3],
  },
  paperDatagrid: {
    width: "100%",
    borderRadius: "16px",
    overflow: "hidden",
    border: `1px solid ${alpha(theme.palette.text.primary, 0.08)}`,
    backgroundColor: theme.palette.background.paper,
  },
  titleDatagrid: {
    color: theme.palette.text.primary,
    fontWeight: 700,
    padding: "12px 16px",
  },
  statusList: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    marginTop: "4px",
  },
  statusRow: {
    display: "grid",
    gridTemplateColumns: "120px 1fr 64px",
    gap: "10px",
    alignItems: "center",
    "@media (max-width: 600px)": {
      gridTemplateColumns: "1fr",
      gap: "4px",
    },
  },
  statusLabel: {
    color: theme.palette.text.secondary,
    fontSize: "12px",
    fontWeight: 700,
  },
  statusValue: {
    color: theme.palette.text.primary,
    fontSize: "12px",
    fontWeight: 800,
    textAlign: "right",
    "@media (max-width: 600px)": {
      textAlign: "left",
    },
  },
  progressTrack: {
    height: "8px",
    borderRadius: "8px",
    backgroundColor: alpha(theme.palette.text.primary, 0.08),
    overflow: "hidden",
  },
  progressBar: {
    height: "100%",
    borderRadius: "8px",
  },
});

export default styles;
